const configuredAppUrl = import.meta.env.VITE_APP_URL?.trim();

function normalizeAppUrl(url: string): string {
  return url.replace(/\/+$/, "");
}

export function getAppUrl(): string {
  if (configuredAppUrl) {
    return normalizeAppUrl(configuredAppUrl);
  }

  return normalizeAppUrl(window.location.origin);
}
